export const authHeader = () => ({
  "Content-type": "application/json; charset=UTF-8",
  "Authorization": "Bearer " + localStorage.getItem('caav_token')
});
